import styled from "styled-components";

export const LayoutContainer = styled.div`
    min-height: 100vh;
    `;